import React from 'react'
import { values } from 'lodash'
import { Link } from 'react-router'
import ReactMarkdown from 'react-markdown'

import { Modal, Panel } from 'react-bootstrap'

import Button from '../components/Button'
import { replaceTokensWithDictionary } from '../lib/text.js'
import { countAdults, countKids, getLeaderName } from '../../lib/TripTools'

const emailBody = ({ trip, supplier, activity, reservation }) => {
  const peopleArray = values(trip.people.data)

  const fields = {
    Contacto: supplier.contactPerson,
    Proveedor: supplier.name,
    Actividad: activity.name,
    Fecha: reservation.date,
    Hora: reservation.time,
    Personas: peopleArray.length,
    Adultos: countAdults(trip),
    Ninos: countKids(trip),
    Cliente: getLeaderName(trip)
  }

  return replaceTokensWithDictionary(supplier.reservationEmailTemplate, fields)
}

const emailSubject = (reservation) => (
  `Reserva Chinespain (${reservation.date})`
)

const getEmailLink = ({ email, trip, supplier, activity, reservation }) => (
  `mailto:${email}`
  + `?subject=${encodeURIComponent(emailSubject(reservation))}&`
  + "cc=${supplier.reservationsCC}&"
  + `body=${encodeURIComponent(emailBody({ trip, supplier, activity, reservation }))}`
)


const SupplierModal = ({ onClose, trip, supplier, activity, reservation }) => {

  const phone = supplier.useReservationsPhone ? supplier.reservationsPhone : supplier.phoneNumber
  const email = supplier.useReservationsEmail ? supplier.reservationsEmail : supplier.email

  const emailLink = getEmailLink({ email, trip, supplier, activity, reservation })

  const hasLeaderName = getLeaderName(trip)

  return (
    <Modal show onHide={() => onClose()}>
      <Modal.Header>Reservar {activity.name || activity.title} con {supplier.name}</Modal.Header>
      <Modal.Body>

        {
          supplier.reservationsNotes && (
            <Panel>
              <Panel.Body>
                <ReactMarkdown source={supplier.reservationsNotes} />
              </Panel.Body>
            </Panel>
          )
        }

        {
          supplier.enableReservationsPhone && (
            <div style={{ margin: 10 }}>
              <a href={`tel:${phone}`}>
                <Button glyph="phone">Llamar al {phone}</Button>
              </a>
            </div>
          )
        }

        {
          supplier.enableReservationsEmail && !hasLeaderName && (
            <Panel bsStyle="warning">
              <Panel.Body>
                ⚠️ No se puede generar el mail porque falta el nombre del líder del grupo
              </Panel.Body>
            </Panel>
          )
        }

        {
          supplier.enableReservationsEmail && (
            <div style={{ margin: 10 }}>
              <a href={hasLeaderName ? emailLink : "#"}>
                <Button glyph="envelope" disabled={!hasLeaderName}>
                  Escribir a {email}
                </Button>
              </a>
            </div>
          )
        }

      </Modal.Body>
      <Modal.Footer>
        <Link to={`/private/supplier/${supplier._id}`}>
          <Button glyph="share-alt" style={{ marginRight: 10 }}>Ir a proveedor</Button>
        </Link>
        <Button onClick={() => onClose()}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SupplierModal
